import { defineMessages } from 'react-intl';

const messages = defineMessages({
  zahlenBlock: {
    id: 'Numbers',
    defaultMessage: 'Numbers',
  },
  title: {
    id: 'Number',
    defaultMessage: 'Number',
  },
  description: {
    id: 'description',
    defaultMessage: 'description',
  },
});

export const iconBlockSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.zahlenBlock),
    block: 'icon',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['heading', 'description'],
      },
    ],
    properties: {
      heading: {
        title: props.intl.formatMessage(messages.title),
      },
      description: {
        title: props.intl.formatMessage(messages.description),
        widget: 'richtext',
      },
    },
    required: ['icon'],
  };
};
